/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React from 'react';
import { Toggle } from '@sede-enterprise/shell-ds-react-framework';
import { IToggleProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Toggle/Toggle.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { IMemoisedComponentProp } from '../../types/Common.type';

interface IToggleControl extends IMemoisedComponentProp {
  controllerProps: UseControllerProps;
  label: string;
  handleOnChange?: (value: boolean) => void;
  toggleProps?: IToggleProps;
  description?: string;
  isBlock?: boolean;
}

const FormControlToggle: React.FC<IToggleControl> = ({
  methods,
  controllerProps,
  label,
  handleOnChange,
  toggleProps,
  isBlock = false,
  description,
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;
  const errorMessage = errors?.[name]?.message;
  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) =>
          isBlock ? (
            <div>
              {label && <div>{label}</div>}
              {description && (
                <div
                  style={{
                    fontSize: '12px',
                    color: 'gray',
                    paddingBottom: '4px',
                  }}
                >
                  {description}
                </div>
              )}
              <Toggle
                data-testid={name}
                onChange={(val) => {
                  if (handleOnChange) {
                    handleOnChange(val);
                  }
                  onChange(val);
                }}
                checked={value}
                {...toggleProps}
              />
            </div>
          ) : (
            <Toggle
              data-testid={name}
              label={label}
              onChange={(val) => {
                if (handleOnChange) {
                  handleOnChange(val);
                }
                onChange(val);
              }}
              checked={value}
              {...toggleProps}
            />
          )
        }
      />
      {errorMessage && <ErrorMessage>{errorMessage as string}</ErrorMessage>}
    </>
  );
};
export default FormControlToggle;
